<router-outlet />
@if (showActiveCallConsole()) {
  <app-active-call-console [showFakeCallControls]="fakeCallControls" />
}
